export default __webpack_public_path__ + "static/banner_768-b7c177e8755d6d60afe1f8c73111a5c2.jpg";